module.exports = __webpack_public_path__ + "media/application/images/company/secondary_nav/challenger-values-2bcefa73c7048ca8f1c26e35347bd5ee.jpg";